"use client"

import { useCurrencyStore, SUPPORTED_CURRENCIES } from "@/lib/currency-store"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"

export function CurrencySelector({ className }: { className?: string }) {
  const { currency, setCurrency } = useCurrencyStore()

  const selected = SUPPORTED_CURRENCIES.find((c) => c.code === currency)

  return (
    <Select value={currency} onValueChange={setCurrency}>
      <SelectTrigger className={className ?? "h-8 w-[90px] text-xs"}>
        <span className="font-mono text-muted-foreground mr-0.5">{selected?.symbol}</span>
        <span>{currency}</span>
      </SelectTrigger>
      <SelectContent className="max-h-72">
        {SUPPORTED_CURRENCIES.map((c) => (
          <SelectItem key={c.code} value={c.code} className="text-xs">
            <span className="font-mono mr-1.5 text-muted-foreground">{c.symbol}</span>
            {c.code} — {c.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
